import gql from 'graphql-tag';

export const addRecipientViewMutation = gql`
  mutation addView($revision: Int!) {
    addRecipientView(revision: $revision)
  }
`;

export const downloadDocumentMutation = gql`
  mutation Download {
    download
  }
`;

export const inviteMutation = gql`
  mutation inviteRecipient($payload: InviteRecipientInput!) {
    inviteRecipient(payload: $payload) {
      id
    }
  }
`;

export const transferRightsMutation = gql`
  mutation TransferRights(
    $email: String!
    $mobile: String!
    $firstName: String!
    $lastName: String!
    $companyName: String!
    $title: String!
    $companyNumber: String
    $existingRecipientId: String
  ) {
    transferRights(
      email: $email
      mobile: $mobile
      firstName: $firstName
      lastName: $lastName
      companyName: $companyName
      title: $title
      companyNumber: $companyNumber
      existingRecipientId: $existingRecipientId
    ) {
      id
    }
  }
`;
